import { useEffect } from "react";
import URLService from "../service/urlService";
import { useAppSelector } from "../store/hooks";

function RedirectToDepartureAnalyst() {
	const { isLogin, kcObject } = useAppSelector(
		(state) => state.authenticationSlice
	);

	useEffect(() => {
		window.location.href = URLService.generateRedirectUrl(
			window._env_.REACT_APP_DEPARTURE_ANALYST_URL +
			"?access_token=" +
			kcObject?.token
		);
	}, []);

	return null;
}

export default RedirectToDepartureAnalyst;
